// EmailJS Configuration
// Replace these values with your actual EmailJS credentials

export const EMAILJS_CONFIG = {
  // Your EmailJS Service ID (found in EmailJS dashboard)
  SERVICE_ID: 'service_uj31j5b',
  
  // Your EmailJS Template ID (found in EmailJS dashboard)
  TEMPLATE_ID: 'template_f9b0pil',
  
  // Your EmailJS Public Key (found in EmailJS dashboard)
  PUBLIC_KEY: 'Ou0aw164K16ZB1rqP'
};

// EmailJS Template Variables
// These should match the variable names in your EmailJS template
export const TEMPLATE_VARIABLES = {
  from_name: 'from_name',      // Sender's name
  from_email: 'from_email',    // Sender's email
  subject: 'subject',          // Email subject
  message: 'message'           // Email message
};
